export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq1_sell.ee55f94b.mp3";